import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { initializeFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyBf-QBOcwzG_Ukf54lQSbkJr5kN91xiEzU",
  authDomain: "srmg-order-system.firebaseapp.com",
  projectId: "srmg-order-system",
  storageBucket: "srmg-order-system.firebasestorage.app",
  messagingSenderId: "574831474556",
  appId: "1:574831474556:web:0dfd4e4bfc45cb46cb16f9"
};

export const app = initializeApp(firebaseConfig);

export const auth      = getAuth(app);
// Force long-polling: Firestore's default streaming connection can hang
// silently on WebKit (Safari + every iPad browser), leaving getDoc unresolved.
export const db        = initializeFirestore(app, { experimentalForceLongPolling: true });
export const storage   = getStorage(app);
export const functions = getFunctions(app, "us-central1");